module.exports = __webpack_public_path__ + "static/og-imageLarge-4b73652ced05a57c4a8f48f74ee33ef5.jpg";